import React, { useRef, useState } from 'react'
import ImageBuffer from '../../ImageBuffer/ImageBuffer'
import {Badge, ReadMore, SubCover, SubHeader} from '../..'
import { ArrowForwardRounded } from '@mui/icons-material'
import { hero1 } from '../../../assets'

import './about.css'

const About = () => {
    const modalNavRef                             = useRef<HTMLDivElement | null>(null);
    const [openSubMegaMenu, setOpenSubMegaMenu]   = useState<number | null>(null);
    const [toggleResult, setToggleResult]         = useState<boolean>(false);

    const handleToggleAboutMore = (index: number) => {
        setToggleResult(true)
        setOpenSubMegaMenu(prev => (prev === index ? null : index));
    }

    const handleCloseCover = () => {
        setToggleResult(false)
        setOpenSubMegaMenu(null);
    }
    
    const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (modalNavRef.current === e.target) {
            closeAboutModal();
        }
    };

    const closeAboutModal = () => {
        setToggleResult(false);
        setOpenSubMegaMenu(null);
    };

  return (
    <>
        <div id="about" className='about-wrapper'>
            <Badge title="Our Story" />
            <SubHeader title="" description="" />
            <div className="about-container">
                <div className="about-main-box-image-cover">
                    <ImageBuffer className="about-main-box-image" src={hero1} alt="" />
                </div>
                <div className="about-main-box">
                    <h1 className="about-main-description">Our Story</h1>
                    <div className="about-main-gradient"></div>
                    <p className="about-main-8">Shalom Springs of Plano is a residential care home dedicated to providing exceptional care and services for seniors.</p>
                    <p className="about-main-4">Our experienced staff is committed to creating a warm and welcoming environment for all residents.</p>
                    <button className="about-main-read-more-btn-cover" onClick={() => handleToggleAboutMore(1)}>
                        <span>Read more</span>
                        <ArrowForwardRounded />
                    </button>
                    <ReadMore onOpen={toggleResult} onClose={closeAboutModal} openSubMegaMenu={openSubMegaMenu} />
                </div>
            </div>
        </div>
        {openSubMegaMenu !== null && (
            //z-index: 3, others should be higher
            <SubCover handleCloseCover={handleCloseCover} />
        )}
    </>
  )
}

export default About